/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { __decorate } from "tslib";
import { ERR_INVALID_ARGUMENT } from "../../utils/error";
import { soapAttribute, SoapRequestData, SoapService } from "../SoapService";
////////
// request types
export class ClientMessage extends SoapRequestData {
    constructor() {
        super();
        this.target = "";
        this.messageId = "";
    }
}
__decorate([
    soapAttribute()
], ClientMessage.prototype, "target", void 0);
__decorate([
    soapAttribute()
], ClientMessage.prototype, "messageId", void 0);
export class CustomerData extends SoapRequestData {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tData = new CustomerData();
        tData.customerNumber = pSoapData.customerNumber;
        tData.salutation = pSoapData.salutation;
        tData.firstName = pSoapData.firstName;
        tData.lastName = pSoapData.lastName;
        tData.emailAddr = pSoapData.emailAddr;
        tData.company = pSoapData.company;
        tData.organization = pSoapData.organization;
        tData.streetAddr = pSoapData.streetAddr;
        tData.city = pSoapData.city;
        tData.stateOrProvince = pSoapData.stateOrProvince;
        tData.cityCode = pSoapData.cityCode;
        tData.poBox = pSoapData.poBox;
        tData.postalCode = pSoapData.postalCode;
        tData.poBoxPostalCode = pSoapData.poBoxPostalCode;
        tData.country = pSoapData.country;
        tData.language = pSoapData.language;
        tData.phone = pSoapData.phone;
        tData.fax = pSoapData.fax;
        return (tData);
    }
}
export class GetSystemInformationOptions extends SoapRequestData {
}
__decorate([
    soapAttribute()
], GetSystemInformationOptions.prototype, "operatingSystem", void 0);
__decorate([
    soapAttribute()
], GetSystemInformationOptions.prototype, "runtime", void 0);
__decorate([
    soapAttribute()
], GetSystemInformationOptions.prototype, "memory", void 0);
__decorate([
    soapAttribute()
], GetSystemInformationOptions.prototype, "application", void 0);
__decorate([
    soapAttribute()
], GetSystemInformationOptions.prototype, "server", void 0);
export class ImportFileOptions extends SoapRequestData {
}
export class LoadSessionOptions extends SoapRequestData {
}
__decorate([
    soapAttribute()
], LoadSessionOptions.prototype, "assignNewProjectId", void 0);
export class LogConfig extends SoapRequestData {
}
__decorate([
    soapAttribute()
], LogConfig.prototype, "maxRecordCount", void 0);
__decorate([
    soapAttribute()
], LogConfig.prototype, "discardOldest", void 0);
__decorate([
    soapAttribute()
], LogConfig.prototype, "storeStackTrace", void 0);
__decorate([
    soapAttribute()
], LogConfig.prototype, "timeZoneId", void 0);
export class LogFilter extends SoapRequestData {
}
export class LogFilterSpec extends SoapRequestData {
}
__decorate([
    soapAttribute()
], LogFilterSpec.prototype, "level", void 0);
__decorate([
    soapAttribute()
], LogFilterSpec.prototype, "facility", void 0);
__decorate([
    soapAttribute()
], LogFilterSpec.prototype, "origin", void 0);
export class ProjectData extends SoapRequestData {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tData = new ProjectData();
        tData.number = pSoapData.number;
        tData.name = pSoapData.name;
        tData.description = pSoapData.description;
        tData.personInCharge = pSoapData.personInCharge;
        tData.extRefNr = pSoapData.extRefNr;
        tData.extRefText = pSoapData.extRefText;
        return (tData);
    }
}
export class ProjectSettings extends SoapRequestData {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tSettings = new ProjectSettings();
        tSettings.projectData = ProjectData.FromSoap(pSoapData.projectData);
        tSettings.customerData = CustomerData.FromSoap(pSoapData.customerData);
        return (tSettings);
    }
}
export class ResolveURIsOptions extends SoapRequestData {
}
__decorate([
    soapAttribute()
], ResolveURIsOptions.prototype, "serverBase", void 0);
export class SaveSessionOptions extends SoapRequestData {
}
export class StringPair extends SoapRequestData {
    constructor(pFirst = "", pSecond = "") {
        super();
        this.first = pFirst;
        this.second = pSecond;
    }
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, StringPair.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tPair = new StringPair();
        tPair.first = pSoapData.first;
        tPair.second = pSoapData.second;
        return (tPair);
    }
}
////////
// response types
export class ApplicationInformation {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tInfo = new ApplicationInformation();
        tInfo.appName = pSoapData.appName;
        tInfo.appKey = pSoapData.appKey;
        tInfo.appVersion = pSoapData.appVersion;
        tInfo.vendorKey = pSoapData.vendorKey;
        return (tInfo);
    }
}
export class CallSite {
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, CallSite.FromSoapNU));
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, CallSite.FromSoapNU));
    }
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tCallsite = new CallSite();
        tCallsite.className = pSoapData.className;
        tCallsite.methodName = pSoapData.methodName;
        tCallsite.fileName = pSoapData.fileName;
        tCallsite.lineNumber = SoapService.SoapDataToInt(pSoapData.lineNumber);
        return (tCallsite);
    }
    static FromSoapNU(pSoapData) {
        const tCallsite = CallSite.FromSoap(pSoapData);
        if (tCallsite == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (tCallsite);
    }
}
export class FaultInfo {
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, FaultInfo.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tInfo = new FaultInfo();
        tInfo.message = pSoapData.message;
        tInfo.stackTrace = CallSite.FromSoapArrayNU(pSoapData.stackTrace);
        tInfo.type = pSoapData.type;
        return (tInfo);
    }
}
export class LogData {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tData = new LogData();
        tData.data = LogRecord.FromSoapArrayNU(pSoapData.data);
        tData.discarded = SoapService.SoapDataToInt(pSoapData.discarded);
        tData.suppressed = SoapService.SoapDataToInt(pSoapData.suppressed);
        return (tData);
    }
}
export class LogRecord {
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, LogRecord.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tRecord = new LogRecord();
        tRecord.cause = FaultInfo.FromSoapArray(pSoapData.cause);
        tRecord.message = pSoapData.message;
        tRecord.origin = CallSite.FromSoap(pSoapData.origin);
        tRecord.facility = pSoapData.facility;
        tRecord.level = pSoapData.level;
        tRecord.timeStamp = pSoapData.timeStamp;
        return (tRecord);
    }
}
export class SendMessageResult {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tResult = new SendMessageResult();
        tResult.messages = ServerResponse.FromSoapArrayNU(pSoapData.messages);
        tResult.sessionAlive = SoapService.SoapDataToBool(pSoapData.sessionAlive);
        return (tResult);
    }
}
export class ServerInformation {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tInfo = new ServerInformation();
        tInfo.maxConcurrentSessionCount = SoapService.SoapDataToInt(pSoapData.maxConcurrentSessionCount);
        tInfo.openSessionCount = SoapService.SoapDataToInt(pSoapData.openSessionCount);
        tInfo.activeSessionCount = SoapService.SoapDataToInt(pSoapData.activeSessionCount);
        tInfo.sessionTimeout = SoapService.SoapDataToInt(pSoapData.sessionTimeout);
        tInfo.sessionSuspendTimeout = SoapService.SoapDataToInt(pSoapData.sessionSuspendTimeout);
        return (tInfo);
    }
}
export class ServerResponse {
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ServerResponse.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tResponse = new ServerResponse();
        tResponse.data = StringPair.FromSoapArray(pSoapData.data);
        tResponse.errorDetail = SoapService.SoapDataToArray(pSoapData.errorDetail);
        tResponse.origin = pSoapData.origin;
        tResponse.messageId = pSoapData.messageId;
        tResponse.statusCode = pSoapData.statusCode;
        tResponse.targetErrorCode = pSoapData.targetErrorCode;
        return (tResponse);
    }
}
export class SystemInformation {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tInfo = new SystemInformation();
        tInfo.operatingSystem = pSoapData.operatingSystem;
        tInfo.runtime = pSoapData.runtime;
        tInfo.memory = pSoapData.memory;
        tInfo.application = ApplicationInformation.FromSoap(pSoapData.application);
        tInfo.server = ServerInformation.FromSoap(pSoapData.server);
        return (tInfo);
    }
}
